"use client";

import { track } from "@/lib/integrations/analytics/tracker";
import React from "react"

import { ErrorCard } from "./ErrorCard"

const isDevelopment = process.env.NODE_ENV === "development";

interface ErrorBoundaryState {
  hasError: boolean;
  errorMessage: string;
}

export class ErrorBoundary extends React.Component<any, ErrorBoundaryState> {
  constructor(props:any) {
    super(props)
    this.state = { hasError: false, errorMessage: "" }
  }
  static getDerivedStateFromError(error:any) { 
    return { hasError: true }
  }
  componentDidCatch(error:any, info:any) {
    if(!isDevelopment) {
      track("error", {
        message: error.message,
        stack: error.stack,
      });
    }
    // You can use your own error logging service here
    console.error("ErrorBoundary caught an error", error, info);
    this.setState({ errorMessage: `${error} ${info?.componentStack}`})
    
  }
  render(){
    if (this.state.hasError) {
      return (
        <ErrorCard message={this.state.errorMessage} />
      )
    }
  
    return this.props.children
  }
}
